import './style.scss'
import { useContext, useRef, useState } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import UserContext from 'src/provider/state-manager/userProvider'
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenContainer, UploadContainer } from "src/style"
import utility from "src/utils/utility"
// import {ReactComponent as UploadIcon} from 'src/assets/img/upload-icon.svg'
import UploadIcon from 'src/assets/svg/onboarding-upload-icon'
//import {ReactComponent as PicIcon} from 'src/assets/img/pics-icon.svg'
import PicIcon from 'src/assets/svg/pics-icon'
import helpers from 'src/utils/helpers'
import { useNavigate } from 'react-router-dom'
import { FiChevronDown } from 'react-icons/fi'
import { RiDeleteBinLine } from 'react-icons/ri'
import { IoArrowBackOutline } from 'react-icons/io5'


export const IdentityVerificationD3: React.FC<any> = () => {
    const navigate = useNavigate()
    const {user: {onboardingInput}, setUserProperty} = useContext(UserContext)
    const {info, setInfoProperty} = useContext(AppInfoContext)
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({
        identificationType: onboardingInput?.identificationType || '', 
        identificationID: onboardingInput?.identificationID || '', 
        identificationImage: onboardingInput?.identificationImage ||'',
        identificationImageName: onboardingInput?.identificationImageName || ''
    })
    const [isHover, setIsHover] = useState(false)
    const idImageRef = useRef<any>(null);

    const idType = ["Driver's License", "International Passport", "National ID / NIN Slip", "Virtual NIN", "Voter's card"]

    async function handleFile (e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files instanceof FileList) {
            if(!helpers.isValidFileType(e.target.value)) {
                setInput({...input, [e.target.name]: ''})
                return notifier.show('Only PNG, JPG and JPEG files are allowed', 'Validation Error')
            }
            let name = e.target.files[0].name

            helpers.convertFileToBase64(e.target.files[0])
            .then(async result => {
                console.log({base64: result})
                const response = await API.verifyIdentity({...input, identificationImage: result})
                if (response) setInput({...input, [e.target.name]: result, [`${e.target.name}Name`]: name})
            })
            .catch(err => {
                notifier.show(JSON.stringify(err), 'Validation Error')
            })
        }
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!input.identificationImage) return notifier.show('Kindly provide identification image', 'Validation Response')

        setInfoProperty('onboardingProcessStatus', {...info.onboardingProcessStatus, isIdentityVerified: true})
        setUserProperty('onboardingInput', {...onboardingInput, ...input})
        navigate('/onboarding/credentials-creation')
    }

    return (
        <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
            <CustomContainer className='onboarding-screen-container'>
                <AppText 
                    textSize='3' color='#101828' 
                    bottomMargin='1.5' fontFamily='Gilmer-Bold'
                >
                    Identification
                </AppText>
                <AppSpan>Lets get to know you some more</AppSpan>
                <Form topMargin='2.5' onSubmit={handleSubmit}>
                    <FormGroupWithIcon bottomMargin='2'>
                        <label>Choose your identification type</label>
                        <div className="input-with-icon">
                            <select 
                                placeholder="Select Type"
                                name='identificationType'
                                value={input.identificationType}
                                style={{color: input.identificationType ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                required
                            >
                                <option value="">Select Type</option>
                                <option value="0">Driver's License</option>
                                <option value="1">International Passport</option>
                                <option value="4">Voter's card</option>
                                <option value="2">National ID / NIN Slip</option>
                                <option value="3">Virtual NIN</option>
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FormGroup>
                        <label>ID Number</label>
                        <input 
                            placeholder='Enter ID Number' 
                            name='identificationID'
                            value={input.identificationID}
                            onChange={handleInput}
                            autoComplete="off"
                            required
                        />
                    </FormGroup>
                    { (input.identificationType && input.identificationID && !input.identificationImage) &&
                        <UploadContainer 
                            borderColor='#EAECF0' radius='0.8' minHeight='12.6'
                            padding='1.5' topMargin='2.5' hoverColor="#0D968F"
                            className='doc-upload-container'
                            onClick={() => idImageRef.current.click()}
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                        >
                            <UploadIcon isHover={isHover} className='icon-component' />
                            <input type="file" name='identificationImage' onChange={handleFile} ref={idImageRef} className="file-input" id="idDoc" />
                            <AppLabel color='#0A756F' fontWeight='600' topMargin='1' htmlFor='idDoc'>Click to upload {idType[input.identificationType]}</AppLabel>
                            <AppSpan color='#667085' textSize='1.2' topMargin='0.3'>PNG or JPG</AppSpan>
                        </UploadContainer>
                    }

                    { input.identificationImage &&
                        <GridContainer 
                            borderColor='#0D968F' radius='0.8' minHeight='9.6'
                            padding='1' topMargin='2'
                        >
                            <FlexRow alignItems='flex-start'>
                                <AbsoluteContainer top='0' right='0'>
                                    <AppSpan 
                                        textSize='1.8' color='#667085' hoverColor='#F80000' cursor='pointer'
                                        onClick={() => setInput({...input, identificationImage: ''})}
                                    >
                                        <RiDeleteBinLine />
                                    </AppSpan>
                                </AbsoluteContainer>
                                <PicIcon 
                                    className='icon-component' 
                                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                />
                                <CustomContainer leftMargin='1.5'>
                                    <AppLabel color='#344054' fontWeight='600'>{input.identificationImageName}</AppLabel>
                                    <AppText color='#667085' topMargin='-0.7' >{helpers.getFileSize(input.identificationImage)} KB</AppText>
                                    <FlexRow gap='1'>
                                        <CustomContainer width='85' height='0.8' sizeUnit='%' bgColor='#EAECF0' radius='0.4' overflow='hidden' >
                                            <CustomContainer bgColor='#0D968F' height='0.8' radius='0.4' width='100' sizeUnit='%'/>
                                        </CustomContainer>
                                        <AppSpan color='#344054' fontWeight='600'>100%</AppSpan>
                                    </FlexRow>
                                </CustomContainer>
                            </FlexRow>
                        </GridContainer>
                    }
                    <FlexRow justifyContent='flex-end' topMargin='2.5' gap='1.5'>
                        <Button 
                            width='9.3' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            childHoverColor='#0D968F' type="button"
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                <IoArrowBackOutline/>
                            </AppSpan>
                            Back
                        </Button>
                        <Button 
                            width='8.8' height='4'
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Proceed
                        </Button>
                    </FlexRow>
                </Form>
            </CustomContainer>
        </ScreenContainer>
    )
}
